import React from 'react'
import { Text, Card, useStyles } from '@ion-ui/core'
import { useMediaQuery } from 'react-responsive'
import { Styles } from './styles.js'

const CarouselCard = ({
  title,
  description,
  img,
  link
}) => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' })
  const styles = useStyles(Styles)

  return (
    <Card variant='press' data-value='1'
      css={styles.dataContainer}>
      <a href={link} target='_blank'
        rel='noreferrer'>
        <img
          alt={title}
          src={img}
          width={isMobile ? '160' : '170'}
          height={isMobile ? '31' : '40'}
        />
        <Text variant='paragraph'>{description}</Text>
      </a>
    </Card>
  )
}

export default CarouselCard
